export enum ProductDownloadTabEnum {
  thumbnail = 'thumbnail',
  checkout = 'checkout',
  digital_download = 'digital_download',
  thank_you = 'thank_you',
}

export const tabLocoKeys: Record<ProductDownloadTabEnum, string> = {
  [ProductDownloadTabEnum.thumbnail]: 'dashboard.store.item.thumbnail',
  [ProductDownloadTabEnum.checkout]: 'dashboard.store.item.checkout',
  [ProductDownloadTabEnum.digital_download]: 'dashboard.digital_product.resources.download.title',
  [ProductDownloadTabEnum.thank_you]: 'dashboard.store.item.thank_you_page',
}
